(() => {
  const carousels = new Map();
  function initializeCarousels(root) {
    root.querySelectorAll('[data-rf-carousel]').forEach(carousel => {
      if (carousels.has(carousel)) return;
      const slides = [...carousel.querySelectorAll('[data-rf-slide]')];
      if (slides.length < 2) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const controls = carousel.querySelector('.rf-carousel-controls');
      const pause = carousel.querySelector('[data-rf-pause]');
      const dots = [...carousel.querySelectorAll('[data-rf-go]')];
      const status = carousel.querySelector('[data-rf-carousel-status]');
      const track = carousel.querySelector('.rf-carousel-slides');
      let index = 0, timer = null, paused = reduced.matches, hovered = false, focused = false;
      const interval = Math.max(4000, Number(carousel.dataset.interval) || 6000);
      let warmup = null;
      function warmNext() {
        const image = slides[(index + 1) % slides.length].querySelector('img');
        if (image && !image.complete) image.loading = 'eager';
      }
      function schedule() {
        window.clearTimeout(timer);
        window.clearTimeout(warmup);
        timer = null;
        if (!paused && !hovered && !focused && !document.hidden) {
          // Fetch only the upcoming slide, after the first banner has priority.
          warmup = window.setTimeout(warmNext, Math.max(1000, interval - 2500));
          timer = window.setTimeout(() => show(index + 1), interval);
        }
      }
      function show(next, manual = false) {
        index = (next + slides.length) % slides.length;
        const image = slides[index].querySelector('img');
        if (image) image.loading = 'eager';
        slides.forEach((slide, position) => { slide.hidden = position !== index; });
        dots.forEach((dot, position) => dot.setAttribute('aria-current', String(position === index)));
        if (manual) status.textContent = slides[index].getAttribute('aria-label');
        schedule();
      }
      function updatePause() {
        pause.querySelector('[data-rf-playback-icon]').setAttribute('d', paused ? 'M7 3v18l14-9z' : 'M5 3h4v18H5z M15 3h4v18h-4z');
        pause.setAttribute('aria-label', paused ? 'Start banner rotation' : 'Pause banner rotation');
        pause.title = paused ? 'Start banner rotation' : 'Pause banner rotation';
        track.setAttribute('aria-live', paused ? 'polite' : 'off');
        schedule();
      }
      controls.hidden = false;
      carousel.querySelector('[data-rf-arrows]').hidden = false;
      carousel.querySelector('[data-rf-prev]').addEventListener('click', () => show(index - 1, true), options);
      carousel.querySelector('[data-rf-next]').addEventListener('click', () => show(index + 1, true), options);
      dots.forEach((dot, position) => dot.addEventListener('click', () => show(position, true), options));
      pause.addEventListener('click', () => { paused = !paused; updatePause(); }, options);
      carousel.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { hovered = true; schedule(); } }, options);
      carousel.addEventListener('pointerleave', () => { hovered = false; schedule(); }, options);
      carousel.addEventListener('focusin', () => { focused = true; schedule(); }, options);
      carousel.addEventListener('focusout', event => { focused = carousel.contains(event.relatedTarget); schedule(); }, options);
      document.addEventListener('visibilitychange', schedule, options);
      reduced.addEventListener('change', () => { paused = reduced.matches; updatePause(); }, options);
      carousel.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const selected = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (selected >= 0) { paused = true; updatePause(); show(selected, true); }
      }, options);
      carousels.set(carousel, () => { window.clearTimeout(timer); window.clearTimeout(warmup); controller.abort(); });
      updatePause();
    });
  }
  function initialize(root = document) {
    initializeCarousels(root);
    root.querySelectorAll('[data-rf-products]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const filters = section.querySelector('.rf-filters');
      if (!filters) return;
      filters.hidden = false;
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-filter]');
        if (!button) return;
        const value = button.dataset.filter;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let count = 0;
        section.querySelectorAll('[data-group]').forEach(card => {
          card.hidden = value !== 'all' && card.dataset.group !== value;
          if (!card.hidden) count += 1;
        });
        section.querySelector('[data-filter-status]').textContent = `${count} products shown: ${button.textContent.trim()}.`;
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    carousels.forEach((destroy, carousel) => {
      if (event.target.contains(carousel)) { destroy(); carousels.delete(carousel); }
    });
  });
})();
